import React from 'react';
import { motion } from 'framer-motion';
import { ClosingLine, InteriorSlide, SlideTitle } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { campaignLoop } from '../../data/snakkerStory';
export function SlideCampaign({}: SlideProps) {
  return <InteriorSlide surface data-id="element-326" data-mp="o41keul8pg21">
      <SlideTitle eyebrow="From Snak to campaign" data-id="element-327" data-mp="o3s4jztwspa2">
        One Snak can be an asset. <span className="text-[var(--brand)]" data-id="element-328" data-mp="123krrl688nda">Or the beginning of a campaign.</span>
      </SlideTitle>

      <div className="relative mt-[clamp(1.5rem,3vw,2.75rem)] flex min-h-0 flex-1 flex-col" data-id="element-329" data-mp="y2haqvcg0lah">
        <ol className="relative grid flex-shrink-0 grid-cols-5" aria-label="Campaign loop" data-id="element-330" data-mp="1btmd45773roi">
          <li className="absolute left-[10%] right-[10%] top-[clamp(1.4rem,2.2vw,2rem)] h-px bg-[var(--fg)]/20" aria-hidden="true" data-id="element-331" data-mp="16uj9mp6v5tin" />
          {campaignLoop.map((step, i) => <motion.li key={step.node} initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15 + i * 0.1,
          duration: 0.45
        }} className="relative flex flex-col items-center text-center" data-id="element-332" data-mp="1lpphzitfm4f5" data-mpi={i}>
              <span className={`relative z-10 flex h-[clamp(2.8rem,4.4vw,4rem)] w-[clamp(2.8rem,4.4vw,4rem)] items-center justify-center rounded-full text-[clamp(0.9rem,1.4vw,1.3rem)] font-extrabold ${i === 1 ? 'bg-[var(--brand)] text-white' : 'border border-[var(--fg)]/15 bg-white text-[var(--fg)]'}`} data-id="element-333" data-mp="1ezhrwxoevbq4">
                {i + 1}
              </span>
              <h3 className={`mt-[clamp(0.6rem,1.1vw,0.9rem)] text-[clamp(1.05rem,1.9vw,1.8rem)] font-extrabold tracking-[-0.035em] ${i === 1 ? 'text-[var(--brand)]' : 'text-[var(--fg)]'}`} data-id="element-334" data-mp="22my8x4687k1r">
                {step.node}
              </h3>
            </motion.li>)}
        </ol>

        <svg className="mx-[10%] mt-2 h-[clamp(1.5rem,3vw,2.5rem)] w-[80%] flex-shrink-0" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" data-id="element-335" data-mp="2bltfihd6mw5l">
          <motion.path d="M 100 0 C 100 18, 100 18, 90 18 L 10 18 C 0 18, 0 18, 0 0" fill="none" stroke="var(--brand)" strokeOpacity="0.45" strokeDasharray="1.5 1.5" vectorEffect="non-scaling-stroke" initial={{
          pathLength: 0
        }} animate={{
          pathLength: 1
        }} transition={{
          delay: 0.75,
          duration: 0.9
        }} data-id="element-336" data-mp="gl9i4dt4bfcu" />
        </svg>

        <div className="mt-[clamp(0.75rem,1.5vw,1.25rem)] grid min-h-0 flex-1 grid-cols-5 gap-[clamp(0.5rem,1vw,0.9rem)]" data-id="element-337" data-mp="zd29k3sjgsig">
          {campaignLoop.map((step, i) => <motion.div key={step.node} initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.45 + i * 0.08,
          duration: 0.45
        }} className="flex min-h-0 flex-col rounded-2xl bg-white p-[clamp(0.85rem,1.5vw,1.3rem)] ring-1 ring-[var(--fg)]/[0.06]" data-id="element-338" data-mp="197uanhlbxxhz" data-mpi={i}>
              <p className="font-mono text-[clamp(0.55rem,0.72vw,0.68rem)] uppercase tracking-[0.16em] text-[var(--brand)]" data-id="element-339" data-mp="1ljo6fraex70j">{step.channel}</p>
              <p className="mt-2 text-[clamp(0.82rem,1.15vw,1.08rem)] font-semibold leading-snug text-[var(--fg)]" data-id="element-340" data-mp="1qhy54bvcipqw">{step.example}</p>
            </motion.div>)}
        </div>
        <p className="mt-2 flex-shrink-0 font-mono text-[clamp(0.55rem,0.7vw,0.66rem)] uppercase tracking-[0.16em] text-[var(--muted)]" data-id="element-341" data-mp="1grmqnve1cy5r">
          REKOVELLE example
        </p>
      </div>

      <ClosingLine delay={0.9} data-id="element-342" data-mp="17s9olns8rbv2">
        Every round can make the <span className="text-[var(--brand)]" data-id="element-343" data-mp="17pn82yndhm0p">next conversation more relevant.</span>
      </ClosingLine>
    </InteriorSlide>;
}